import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback, useRef } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import Button from 'src/components/design-system/Button';
import { InvoiceContext } from 'src/sections/invoice_details/InvoiceDetailsContext';
import { useContextSelector } from 'use-context-selector';

const InvoiceDeleteActionCell = (props: GridCellProps) => {
  const setInvoiceBudgetPeriods = useContextSelector(
    InvoiceContext,
    (value) => value.setInvoiceBudgetPeriods
  );
  const deleteButtonRef = useRef<HTMLButtonElement>(null);
  const { dataItem, dataIndex } = props;
  const handleDeleteCell = useCallback(() => {
    setInvoiceBudgetPeriods((prev) => {
      const items = [...prev];
      items?.splice(dataIndex, 1);
      return items;
    });
  }, [dataIndex, setInvoiceBudgetPeriods]);

  return (
    <GridCellBase {...props}>
      {!!dataItem.isDeletable && (
        <Button onClick={handleDeleteCell} ref={deleteButtonRef} color="error" size="md">
          Delete
        </Button>
      )}
    </GridCellBase>
  );
};

export default InvoiceDeleteActionCell;
